"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var feedback_popup_1 = require("../components/common/feedback-popup");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var apollo_client_1 = require("../core/apollo-client");
var QUERY_FEEDBACK_MESSAGE = require("../core/gql/queries/feedback-message");
var AcceptInvite = require("../core/gql/mutations/accept-invite");
var SetFeedbackMessage = require("../core/gql/mutations/set-feedback-message");
var AllOrganizations = require("../core/gql/queries/all-organizations");
var utils_1 = require("../core/utils");
var HubConfigurator = function (App) {
    var token = utils_1.getParameterByName(window.location.href, "token");
    if (token && window.location.pathname == "/accept") {
        utils_1.redirectToLogin(utils_1.currentBaseUrl() + "?token=" + token);
        token = null;
    }
    var resultStatuses = {
        errorAlreadyTaken: "ERROR_ALREADY_TAKEN",
        success: "SUCCESS",
    };
    var inviteAccepted = "accepted";
    var handleInviteAcceptResponse = function (data) {
        var acceptInvite = data.acceptInvite;
        var invitation = acceptInvite.invitation, result = acceptInvite.result;
        var organizationId = invitation.organizationId, status = invitation.status;
        if (status === inviteAccepted && result === resultStatuses.success) {
            utils_1.redirectToOrgPrograms(organizationId);
        }
        else if (result === resultStatuses.errorAlreadyTaken) {
            apollo_client_1.default.mutate({
                mutation: SetFeedbackMessage.MUTATION,
                variables: {
                    message: "This invitation has already been accepted by another user. Please contact an administrator.",
                    autoclose: true,
                    isError: true,
                },
            });
        }
        token = null;
    };
    if (token) {
        // Delay this to allow the dashboard to render and the query to start listening to refetches.
        apollo_client_1.default.mutate({
            mutation: AcceptInvite.MUTATION,
            variables: { token: token },
            refetchQueries: function () { return [{ query: AllOrganizations.QUERY }]; },
        }).then(function (_a) {
            var data = _a.data;
            handleInviteAcceptResponse(data);
        }).catch(function (_a) {
            var graphQLErrors = _a.graphQLErrors;
            apollo_client_1.default.mutate({
                mutation: SetFeedbackMessage.MUTATION,
                variables: {
                    message: "This token is invalid. Please contact an administrator.",
                    autoclose: true,
                    isError: true,
                },
            });
        });
    }
    return function () {
        return (React.createElement(react_apollo_1.ApolloProvider, { client: apollo_client_1.default },
            React.createElement(App, null),
            React.createElement(react_apollo_1.Query, { query: QUERY_FEEDBACK_MESSAGE.QUERY }, function (_a) {
                var loading = _a.loading, data = _a.data;
                if (loading) {
                    return null;
                }
                if (!data || !data.feedbackMessage || !data.feedbackMessage.message) {
                    return null;
                }
                return (React.createElement(react_apollo_1.Mutation, { mutation: SetFeedbackMessage.MUTATION }, function (setFeedbackMessage) {
                    var clear = function () {
                        setFeedbackMessage({
                            variables: {
                                message: null,
                                autoclose: null,
                                isError: null,
                            },
                        });
                    };
                    return (React.createElement(feedback_popup_1.default, { onClose: clear, autoClose: data.feedbackMessage.autoclose, type: data.feedbackMessage.isError ? "negative" : "positive" }, data.feedbackMessage.message));
                }));
            })));
    };
};
exports.default = HubConfigurator;
//# sourceMappingURL=app-configurator.js.map